import type { EditControlProps } from 'src/components/root/components/controls/declare'
import { useContext } from 'react'
import { Input, message } from 'antd'
import { EditPropsContext, EditContext } from 'src/components'
import { mainStore } from 'enasops/stores'
import { $api } from 'src/plugins'
import { getNavFieldsFromNavColumns, getEditSubPageNavFields } from 'src/components/root/helper'
import { initFilter, extendRules, getSingleRule, extendInclude } from 'src/utils/common'

const Channel = (props: EditControlProps) => {
  const editProps = useContext(EditPropsContext)
  const edit = useContext(EditContext)

  const handleChange = (evt: any) => {
    props.onChange?.(evt.target.value)
  }

  const handleAssign = () => {
    $api['app/getDataByPost'](edit.formBase, {
      url: '/OP/Tenant/TenantSetings'
    }).then(res => {
      if (res) {
        message.success('分配成功')

        const { Nav_PageEdit = {}, Nav_SubPageEdits = [] } = edit.editConfig
        const { Nav_PageEdit: deepConfig, Nav_Columns } = Nav_PageEdit
        const { OrgId } = mainStore.headers
        const payload = initFilter({ OrgId })
        extendRules(payload, [getSingleRule('ID', 1, editProps.formData?.formId!)])
        // 编辑表单导航属性
        const pageNavFields = getNavFieldsFromNavColumns(Nav_Columns)
        // 编辑表单子表导航属性
        const subPageNavFields = getEditSubPageNavFields(Nav_SubPageEdits)
        const navFields = pageNavFields.concat(subPageNavFields)
        navFields.length && extendInclude(payload, navFields)
        $api['app/getDataByPost'](payload, {
          url: deepConfig.QUERY_API_URL
        }).then((res: any) => {
          res && edit.editPageTable.activeTable.setDataSource(res.Nav_Channel)
        })
      }
    })
  }

  const { __READONLY__, EDITABLE, PROMPT_INFO } = props.config
  return (
    <Input.Search
      disabled={__READONLY__ || !EDITABLE || props.evtConfig?.disabled}
      placeholder={PROMPT_INFO}
      value={props.value}
      onChange={handleChange}
      enterButton='分配'
      onSearch={handleAssign}
    />
  )
}

export default {
  renderChannel (props: EditControlProps) {
    return <Channel {...props} />
  },
}